import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useTranslation } from 'Shared/util/custom-hooks';
import { funcFilterStatus } from 'Shared/util/translations';
import { joinClassNames as c } from 'Shared/util/styles';
import { isActiveItem } from './menu-utils';
import styles from './default-menu.css';


const renderSubItem = (item) => (
  <NavLink
    exact
    key={`${item.text};${item.link}`}
    to={item.link}
    className={styles.subItem}
    activeClassName={styles.active}
  >
    {item.text}
  </NavLink>
);

const renderMainItem = (item, isActive, t) => (
  <>
    {item.link ? (
      item.externalUrl ? (
        <a
          href={item.link}
          target="_blank"
          rel="noopener noreferrer"
          className={styles.mainItem}
        >
          {item.text}
        </a>
      ) : (
        <NavLink
          exact
          to={item.link}
          className={styles.mainItem}
          activeClassName={styles.active}
        >
          {item.text}
        </NavLink>
      )
    ) : (
      <span className={c(styles.mainItem, isActive && styles.active)}>
        {item.text}
      </span>
    )}
    {item.news && <div className={styles.news}>{t.news}</div>}
  </>
);


const renderItem = (item, currentPage, t) => {
  const isActiveMainItem = isActiveItem(item, currentPage);

  return (
    <div
      key={`${item.text};${item.link}`}
      className={c(styles.itemContainer, (isActiveMainItem && styles.active), (item.subItems && styles.hasSubItems))}
    >
      {renderMainItem(item, isActiveMainItem, t)}
      {item.subItems && (
        <div className={styles.subItemContainer}>
          {item.subItems.map((subItem) => {
            const translatedSubItem = funcFilterStatus(subItem, t, 'text');
            return renderSubItem(translatedSubItem);
          })}
        </div>
      )}
    </div>
  );
};


const DefaultMenu = ({
  items,
  currentPage,
}) => {
  const t = useTranslation(x => x.menuItems);

  return (
    <div className={styles.container}>
      {items.map((item) => {
        const translatedItem = funcFilterStatus(item, t, 'text');
        return renderItem(translatedItem, currentPage, t);
      })}
    </div>
  );
};


DefaultMenu.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string.isRequired,
    link: PropTypes.string,
    subItems: PropTypes.arrayOf(PropTypes.shape({
      text: PropTypes.string.isRequired,
      link: PropTypes.string.isRequired,
    })),
  })).isRequired,
  currentPage: PropTypes.string.isRequired,
};

export default DefaultMenu;
